
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.728 3.237c.621-.673.931-1.009 1.261-1.205a2.588 2.588 0 012.586-.04c.336.187.656.514 1.296 1.168.64.654.96.98 1.142 1.323.44.827.426 1.829-.038 2.642-.192.337-.521.654-1.18 1.289L8.96 15.96c-1.248 1.202-1.872 1.804-2.652 2.108-.78.305-1.638.282-3.353.238l-.233-.007c-.522-.013-.783-.02-.935-.192-.151-.172-.13-.438-.09-.97l.023-.289c.117-1.497.175-2.245.467-2.918.293-.672.797-1.219 1.805-2.311l7.737-8.383zM10.833 3.332l5.834 5.833","stroke":"#141B34","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.667 18.332h6.666","stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    